import React from 'react'

import { Like } from '~/shared/atoms/Like'
import { CarouselContent, CarouselDots, CarouselImage } from '~/shared/molecules/Carousel'

import { CardType } from '..'
import { LikeContainerWide, Photo, PhotoWrapper } from '../CardShards' // TODO

import { StyledCarouselButton, StyledCarouselButtonsWrapper, StyledCarouselItem, StyledCarouselProvider } from './ImageSectionShards'

interface ImageSectionProps {
  type: CardType
  restaurantId: string
  favorited: boolean
  withCarousel: boolean
  restaurantName: string
  sliderImages: {
    id: string
    preview?: string | null
    original?: string | null
  }[]
  autoPlay?: boolean
  showCarouselButtons?: boolean
}

export function ImageSection({
  type,
  restaurantId,
  favorited,
  withCarousel,
  restaurantName,
  sliderImages,
  autoPlay = false,
  showCarouselButtons = false,
}: ImageSectionProps) {
  const isDaily = type === 'daily'
  return (
    <PhotoWrapper>
      <LikeContainerWide>
        <Like restaurantId={restaurantId} favorited={favorited} />
      </LikeContainerWide>
      {withCarousel ? (
        <StyledCarouselProvider fullHeight={isDaily} autoPlay={autoPlay} autoplayOptions={{ delay: 1000 }}>
          <CarouselContent>
            {sliderImages.map((image, i) => {
              return (
                <StyledCarouselItem key={i} fullHeight={isDaily}>
                  <CarouselImage src={image?.preview || image?.original || ''} alt={restaurantName} index={i} />
                </StyledCarouselItem>
              )
            })}
          </CarouselContent>
          {!isDaily && (
            <>
              <StyledCarouselButtonsWrapper>
                {showCarouselButtons && (
                  <>
                    <StyledCarouselButton />
                    <StyledCarouselButton isNext />
                  </>
                )}
              </StyledCarouselButtonsWrapper>
              <CarouselDots />
            </>
          )}
        </StyledCarouselProvider>
      ) : (
        <Photo src={sliderImages[0]?.preview || ''} alt={restaurantName} layout='fill' />
      )}
    </PhotoWrapper>
  )
}
